import gql from "graphql-tag";

export const GET_ALL_BY_COMPONENTID = gql(`
  query($componentId: Int!) {
  componentDataSourceQuery {
        getAllByComponentId(componentId:$componentId) {
  id,          
  dataSourceId,
  componentId,
  name,
  autoSave
  autoLoad
  maxRowsReturned
  applicationId
  applicationVersion
  fcr
  ucr  
  iapComponentDataSourceFieldConfigurations{
      componentDataSourceId
      dataSourceFieldId
      defaultFilterSearch      
      defaultFilterSearchOrder
      autoUpdate
      defaultValue
      defaultValidation
      edit
      add
      editMassive
      import
      fcr
      filterResult
      filterResultOrder
      filterSearch
      filterSearchOrder
      fum
      list
      view
      mandatory
      sortOrder
      idSortType
      dataSourceField{
          tableName
          field
          tableNameAlias,
      fieldAlias,
      dataSourceLookUpId

      }
      
  }
  dataSource{
      id,
      name,
      description,
      idDataSourceType  
      ,
        iapDataSourceDataBase{
          id
          dataSourceId
          idBaseDatos
          idDataBaseType
          querySelect
          queryFrom
          queryWhere
          queryOrderBy
          queryGroupBy
          queryHaving
          fcr
          ucr
          uum
          fum
        },
        iapDataSourceServices{
          id
          dataSourceId
          idHttpMethodType
          idAuthType
          url
          fcr
          ucr
          uum
          fum         
        },   
       iapDataSourceFields{
          id,
          dataSourceId,
          dataSourceTableAliasId
          tableName,
          field,
          tableNameAlias,
          fieldAlias,
          shortDescription,
          description,
          dataSourceLookUpId
  }
  }
            
      }
    }
  }
`);

export const GET_ALL_COMPONENTDATASOURCE = gql(`
query($maxregs: Int) {
    componentDataSourceQuery {
      getAll(maxregs:$maxregs) {
  id,          
  dataSourceId,
  componentId,
  name,
  dataSource{
      id,
      name,
      
        iapDataSourceDataBase{
          id
          dataSourceId
          idBaseDatos
          idDataBaseType
          querySelect
          queryFrom
          queryWhere
          queryOrderBy
          queryGroupBy
          queryHaving
          fcr
          ucr
          uum
          fum
        },
        iapDataSourceServices{
          id
          dataSourceId
          idHttpMethodType
          idAuthType
          url
          fcr
          ucr
          uum
          fum         
        },
       iapDataSourceFields{
     id,
     dataSourceId,
     dataSourceTableAliasId
      tableName,
      field,
      shortDescription,
      description,
      dataSourceLookUpId
  }
     
  }
            
      }
    }
}
`);



export const GET_ALL_ASCENDANCYFROMCOMPONENT = gql(`
query($componentId: Int!) {
    componentDataSourceQuery {
      getAllAscendancyFromComponent(componentId:$componentId) {
  id,          
  dataSourceId,
  componentId,
  name,
  dataSource{
      id,
      name,
       iapDataSourceFields{
          id,
          dataSourceId,
          tableName,
          field,
          dataSourceLookUpId
      
  }
     
  }
            
      }
    }
}
`);